// Timestamps from the API are MySQL DATETIME strings in UTC ("2026-10-17
// 10:24:00"), returned verbatim because the pool sets dateStrings: true.
//
// `new Date("2026-10-17 10:24:00")` is parsed as LOCAL time by every browser,
// which would shift every displayed time by the viewer's offset. These helpers
// pin the value to UTC first, then format in the viewer's own timezone — so an
// IST user sees 15:54 for a row stored as 10:24.

/** Parse a UTC DATETIME string (or ISO string) into a Date. */
export function parseUtc(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const raw = String(value).trim();
  // Already carries a zone designator (…Z or ±HH:MM) — trust it as-is.
  const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/.test(raw)
    ? raw.replace(" ", "T")
    : `${raw.replace(" ", "T")}Z`;

  const d = new Date(normalized);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "17 Oct 2026, 3:54 pm" in the viewer's timezone. */
export function formatDateTime(value) {
  const d = parseUtc(value);
  if (!d) return "—";
  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

/** "3:54 pm" — for columns where the date is already obvious. */
export function formatTime(value) {
  const d = parseUtc(value);
  if (!d) return "—";
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit", hour12: true });
}

/** Full, unambiguous form for tooltips. */
export function formatFull(value) {
  const d = parseUtc(value);
  return d ? d.toLocaleString() : "—";
}
